<template>
  <div :class="['create-date-content ', { 'input-height': heightis40 }]" :style="innerStyle">
       <div>{{label}}</div>
       <el-date-picker
          v-model="createDate"
          :type="type"
          value-format="yyyy-MM-dd"
          :placeholder="$t('Home.seletDate')"
          :default-value="type === 'date' && defaultValue"
          @change="changeDate"
      >
      </el-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '创建日期',
    },
    innerStyle: String,
    heightis40: Boolean,
    type: {
      type: String,
      default: 'date',
    },
    defaultValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      createDate: this.$moment(new Date()).format('YYYY-MM-DD'),
    };
  },
  mounted() {
    this.changeDate(this.createDate);
  },
  methods: {
    changeDate(e) {
      this.$emit('changeDate', e);
      if (e=='') {
        this.createDate = this.$moment(new Date()).format('YYYY-MM-DD');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
 .create-date-content {
   margin-left: 24px;
    :first-child {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      letter-spacing: 0;
      margin-bottom: 4px;
    }
  }

  .input-height {
    ::v-deep .el-input__inner {
        height: 40px;
    }
  }
</style>
